// extracted by mini-css-extract-plugin
export default {"headerSubTab":"style_headerSubTab__gH0Si","headerSubTabLink":"style_headerSubTabLink__HiIpw","active":"style_active__i9nZT"};